var _defs, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 442.02 89.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:none;stroke:#5f6062;}.cls-8{fill:#5f6062;}.cls-9{fill:#ae1f2b;}.cls-10{fill:#fff;}.cls-11{font-size:11.66px;fill:#231f20;font-family:PFDINSerif-Medium, PF DIN Serif;font-weight:500;letter-spacing:0.15em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.15,
    y1: 40.24,
    x2: 92.78,
    y2: 40.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#dfeecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#cee7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b3db95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8dcb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#72bf44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6abd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#55b947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#33b14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#03a751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#00a651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.22,
    y1: 20.49,
    x2: 103.99,
    y2: 20.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.63,
    y1: 30.29,
    x2: 95.46,
    y2: 30.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -148.91,
    y1: -152.33,
    x2: -101.07,
    y2: -118.83,
    gradientTransform: "matrix(1.12, -0.15, -0.12, 0.91, 245.62, 168.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#e5f1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#dfeecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#cee7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b3db95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8dcb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#72bf44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6abb48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#55b153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#339f64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#03887c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#00867e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -170.06,
    y1: -157.7,
    x2: -120.42,
    y2: -157.7,
    gradientTransform: "matrix(1.11, -0.06, -0.22, 0.92, 252.42, 155.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#dfeecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cee7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b3db95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8dcb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#72bf44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6abb48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#55b153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#339f64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#03887c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#00867e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 102.71,
    y1: 19.3,
    x2: 159.42,
    y2: 52.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#dfeecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#cee7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b3db95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8dcb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#72bf44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#60b64d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#319e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00867e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.15,28.31s52.25-1.22,81.19,6.12c8.91,2.21,9.8,7.72,9.89,12.75a42.91,42.91,0,0,0,.55,5.06A17.3,17.3,0,0,0,81.56,40C50,29.26,1.15,28.31,1.15,28.31Z",
    transform: "translate(-0.22 -0.22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.55,22.92c2.42-2.18,7.07-11-10.22-9.44C48.05,16.34.22,23.13.22,23.13s67.17-7,92-4.06c8.69,1,6,7.73,5.6,8.61A29,29,0,0,1,101.53,23Z",
    transform: "translate(-0.22 -0.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.7,23.09C45.89,22.39.63,25.66.63,25.66s46.51-2.32,81.52,3c8.69,1.19,10.89,5.47,11.16,9a36.43,36.43,0,0,1,1.8-5.1C97.24,25.57,89.86,22.67,67.7,23.09Z",
    transform: "translate(-0.22 -0.22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.36,54.85s3.45,12.26,19.35,15.8c24.9,5.79,43.9-9.2,43.9-9.2a34.4,34.4,0,0,1-30,18.73C98.56,80.32,93.36,54.85,93.36,54.85Z",
    transform: "translate(-0.22 -0.22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.65,22.83a28.47,28.47,0,0,0-3.92,4.91c-2.07,5.41,3.57,9.91,12.68,10.32,29.21-.2,41.93-14.76,41.93-14.76L158.44.22s-7.37,14.09-25.78,22c-14.44,6.63-29.25,7.21-31.21,4A2.82,2.82,0,0,1,101.65,22.83Z",
    transform: "translate(-0.22 -0.22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.13,32.43c-1.07,4.23-2,17,23.3,16,33.41-2.47,54.63-26.77,54.63-26.77l-8.75,21.93s-20.77,21.11-50.77,17.14c-20.62-2.79-21.18-17-21.18-17A29.59,29.59,0,0,1,95.13,32.43Z",
    transform: "translate(-0.22 -0.22)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 196.74,
    y1: 0.09,
    x2: 196.74,
    y2: 88.78
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.17,86.57V66.91c0-1.34-.16-6.49-.23-7.59a5.7,5.7,0,0,0-3.32-4.63h9.57V86.57Z",
    transform: "translate(-0.22 -0.22)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.87,45.93A3.81,3.81,0,0,1,36.7,42.1a3.75,3.75,0,0,1,3.75,3.83,3.7,3.7,0,0,1-3.61,3.75A3.83,3.83,0,0,1,32.87,45.93Z",
    transform: "translate(-0.22 -0.22)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M7.57,86.57h9.18a6.35,6.35,0,0,1-2.87-3.74,54.59,54.59,0,0,1-.34-7.61V56.62h6.14V54.68H13.54V51.79c0-7.14,2.45-10.06,6.72-10.06s5.45,4.48,5.45,4.48l4.13-2.39s-2.68-4.07-9.68-4.07S7.56,44.27,7.56,52.6Z",
    transform: "translate(-0.22 -0.22)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M71.22,61.17c-1.57-3.62-4-4.81-6.17-4.81-5.4,0-9.89,4.56-9.89,13.56,0,8.72,3.57,13.89,10.86,13.89,3,0,5.73-1.31,8.23-4l1.39,1.6a14.81,14.81,0,0,1-11.7,5.46c-9.83,0-16-6.39-16-15.46,0-9.89,7.15-17.54,17.17-17,4.28.24,8.37,2.13,10.17,4.22Z",
    transform: "translate(-0.22 -0.22)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 220.58,
    y: 32.84,
    width: 106.79,
    height: 53.39
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M280.53,63.49a14.64,14.64,0,0,1,.47-1.67,6.76,6.76,0,0,1,.6-1.34,13.86,13.86,0,0,0-2.17-.67,14.88,14.88,0,0,0-3.2-.36A6.81,6.81,0,0,0,271,61.28a6.28,6.28,0,0,0-1.81,4.44,5.11,5.11,0,0,0,2.31,4.51,16.26,16.26,0,0,0,3.14,1.67,17.74,17.74,0,0,1,3,1.57,3.4,3.4,0,0,1,1.74,2.84c0,2.27-1.84,3.8-4.51,3.8a7.54,7.54,0,0,1-3.47-.83,9.78,9.78,0,0,1-2.31-1.6,10.43,10.43,0,0,1-1,3.34,10.4,10.4,0,0,0,3.84,1.2,14.29,14.29,0,0,0,2.24.2c3,0,5.24-1,6.67-2.84a6.66,6.66,0,0,0,1.44-4.07,5.49,5.49,0,0,0-.77-2.91c-.63-1-1.6-1.73-3.84-2.84a25.85,25.85,0,0,1-4.34-2.37,3.27,3.27,0,0,1-1.3-2.57,3.13,3.13,0,0,1,3.44-3.2,8.94,8.94,0,0,1,2.14.36A9.76,9.76,0,0,1,280.53,63.49Z",
    transform: "translate(-0.22 -0.22)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M299.42,62.88c-.06-.7-.09-1.23-.09-1.6a9.78,9.78,0,0,1,.16-1.67,15.71,15.71,0,0,1-2.54.17h-3.4l-3.94,0-2.27-.07c.13,2.64.16,3.71.23,5.38v9.15c0,2.4,0,4-.07,4.73s-.13,1.74-.26,3.11C288,82,288.57,82,289,82a21.1,21.1,0,0,1,2.11.14,65.94,65.94,0,0,1-.24-7.42V71.83h3.51a29.39,29.39,0,0,1,4.37.34c-.06-.7-.1-1.24-.1-1.6a10.94,10.94,0,0,1,.17-1.71,21.21,21.21,0,0,1-4,.3h-3.94V63.85l0-1.33h3.57a34,34,0,0,1,3.54.2C298.32,62.75,298.79,62.79,299.42,62.88Z",
    transform: "translate(-0.22 -0.22)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M308.51,59.65a16.41,16.41,0,0,1-1.91.13c-.43,0-1.07-.07-1.93-.17.13,1.27.16,1.74.2,2.78v3.37l0,7.94c0,3.18.1,3.84.87,5.11a6.69,6.69,0,0,0,2,2c1.57,1.1,3.27,1.5,6.38,1.5,2.9,0,4.7-.43,6.31-1.57,2.33-1.63,2.83-3.1,2.83-8.51l0-5.25c0-.43,0-1.56.07-3.4,0-1.4,0-2.4.06-2.94,0-.23.07-.57.11-1-.77.06-1.34.13-1.71.13s-.93-.07-1.67-.13c.13,1.17.2,1.63.23,2.64.11,1.33.14,2.93.14,4.7V72.2c0,3.67-.1,4.47-.8,5.51a4.64,4.64,0,0,1-1.34,1.13,7.17,7.17,0,0,1-4,1c-2.37,0-4.57-.87-5.41-2.1-.67-1-.7-1.4-.73-4.87V66c0-.37,0-1,.06-1.84s0-1.37,0-1.57C308.3,61.45,308.34,61,308.51,59.65Z",
    transform: "translate(-0.22 -0.22)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(335.73 73.06)"
  }, "SIMON FRASER ", /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13.01
  }, "UNIVERSITY"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFic);
export default __webpack_public_path__ + "static/media/fic.8d8d1aacd9b834d02ecaf3b5f705fa59.svg";
export { ForwardRef as ReactComponent };